import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import axios from 'axios';
import { ModernPageContainer, ModernPageHeader } from '../dashboard/components/ModernTable';
import BackButton from '../items/buttons/BackButton';
import LoadingIcon from '../items/buttons/LoadingIcon';

import { Grid, Button, Paper } from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import HistoryIcon from '@mui/icons-material/History';

const getLogByEmail = `${process.env.REACT_APP_SERVER_API}/logs/`;
const getAllLog = `${process.env.REACT_APP_SERVER_API}/allLogs/`;

Date.prototype.toShortFormat = function () {
  let monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  let day = this.getDate();

  let monthIndex = this.getMonth();
  let monthName = monthNames[monthIndex];

  let year = this.getFullYear();

  return `${day}-${monthName}-${year}`;
};

export default function Order(props) {
  const { userEmail, role, referTo } = useContext(UserContext);

  //start at first date of this month
  var date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(
    new Date(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const [startDateString, setStartDateString] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1).toISOString()
  );
  const [endDateString, setEndDateString] = useState(
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString()
  );
  const [loading, setLoading] = useState(true);

  let id = '';
  let group = props.match.params.group;
  let tableTitle = 'Transactions';
  let superAdmin = false;
  if (role === 'SuperAdmin') {
    id = props.match.params.id;
    if (group) tableTitle = `Transactions of ${group}`;
    else tableTitle = `Transactions`;
    superAdmin = true;
  } else if (role === 'Admin') id = userEmail;
  else if (role === 'User') id = referTo;

  useEffect(() => {
    let isCancelled = false;

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleStartDate = (e) => {
    setStartDate(e);
    setStartDateString(e.toISOString());
  };

  const handleEndDate = (e) => {
    setEndDate(e);
    setEndDateString(e.toISOString());
  };

  const handleSearch = async () => {
    console.log(startDateString);
    console.log(endDateString);
    await axios
      .get(
        !group && superAdmin
          ? getAllLog + '/' + startDateString + '/' + endDateString
          : getLogByEmail + id + '/' + startDateString + '/' + endDateString,
        {
          headers: {
            'auth-token': localStorage.getItem('token'),
          },
        }
      )
      .then(async (res) => {
        setLoading(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title="Logs"
        subtitle="View and download system logs and activity history"
        icon={HistoryIcon}
      />

      <Paper sx={{ p: 3, maxWidth: '800px', mx: 'auto' }}>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={5}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={startDate}
                onChange={(e) => handleStartDate(e)}
                label="Select start date"
                format="MM/dd/yyyy"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: 'normal',
                    id: 'date-picker-start',
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={5}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={endDate}
                onChange={(e) => handleEndDate(e)}
                label="Select end date"
                format="MM/dd/yyyy"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: 'normal',
                    id: 'date-picker-end',
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              fullWidth
              sx={{ height: '56px' }}
              variant="contained"
              color="primary"
              onClick={handleSearch}
            >
              Download
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <BackButton />
    </ModernPageContainer>
  );
}
